import { Feed } from './Feed';

export class Condolence extends Feed {
    death_date: Date;
    death_reason: string;
    carnation_date: Date;
    carnation_place: string;
    prayer_date: Date;
    family_member: string;
    other_info: string;
    other_date: string;
    meta: string;
}
